<template>
  <div @click="moveDetail" class="member-card">
    <img
      :src="thumbnailUrl"
      class="member-card-img"
      :class="{ 'first-row': categoryCheck, 'second-row': !categoryCheck }"
    />
    <div class="member-card-text">
      <div class="rank-box">
        <img :src="categoryIconUrl" v-if="showCategoryIcon" class="rank-img" />
      </div>
      <div class="member-text">
        <p class="member-name">{{ memberName }}</p>
        <p class="member-prefecture">{{ prefecture }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "id",
    "thumbnailUrl",
    "categoryIconUrl",
    "memberName",
    "prefecture",
    "showCategoryIcon",
    "categoryCheck"
  ],
  methods: {
    // 詳細ページに遷移する関数
    moveDetail() {
      this.$emit("handleMoveDetail", this.id);
    }
  }
};
</script>

<style lang="css" scoped>
.member-card {
  width: 100%;
  height: 100%;
}
.member-card-img {
  object-fit: cover;
}
.member-card-text {
  text-align: center;
  background-color: white;
  min-height: 110px;
  padding: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first-row {
  height: 100%;
}
.second-row {
  height: 170px;
  width: 200px;
}
.member-text {
  width: 100%;
}
.member-name {
  font-size: 110%;
}
.rank-img {
  height: 40px;
  width: auto;
}
.rank-box {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/leaders/LeadersMemberCard.vue